import {AssetLunarPurchaseOptionPutDataTransferObject} from "../../data-transfer-object/asset/AssetLunarPurchaseOptionPutDataTransferObject"

/**
 * 루나 구매 옵션 속성 설명
 */
export const AssetLunarPurchaseOptionPutDataTransferObjectDescription: Record<keyof AssetLunarPurchaseOptionPutDataTransferObject, string> = {
    lunarAmount: '지급 루나',
    cashAmount: '지불 금액'
}
